'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'
import { ComponentPropsWithoutRef } from 'react'

function Tabs({ className, ...props }: ComponentPropsWithoutRef<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot='tabs' className={cn('flex flex-col', className)} {...props} />
}

function TabsList({ className, ...props }: ComponentPropsWithoutRef<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot='tabs-list'
      className={cn('scrollbar-hide max-lg:scrollbar-hide flex w-full items-center overflow-x-auto overflow-y-hidden py-1', className)}
      {...props}
    />
  )
}

const tabsTriggerVariants = cva(
  'focus-visible:miista-focus select-none items-center justify-center gap-1 whitespace-nowrap uppercase transition-colors ease-out disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        plain: 'text-muted h-miista-button-height-small leading-miista-button-height-small rounded-sm hover:text-current data-[state=active]:text-current',
        button:
          'px-miista-button-padding-x-default h-miista-button-height-default leading-miista-button-height-default backdrop-blur-xs rounded-lg border border-solid border-transparent text-current hover:border-current data-[state=active]:border-current',
      },
    },
    defaultVariants: {
      variant: 'plain',
    },
  },
)

function TabsTrigger({ className, variant, ...props }: ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & VariantProps<typeof tabsTriggerVariants>) {
  return <TabsPrimitive.Trigger data-slot='tabs-trigger' className={cn(tabsTriggerVariants({ variant }), className)} {...props} />
}

function TabsContent({ className, ...props }: ComponentPropsWithoutRef<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content data-slot='tabs-content' className={cn('focus-visible:miista-focus mt-1', className)} {...props} />
}

export { Tabs, TabsContent, TabsList, TabsTrigger }
